import * as React from "react";
import type { SVGProps } from "react";
const SvgOpenInNew = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M18 21a3 3 0 0 0 3-3v-6h-2v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6V3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20 3h-5v2h2.532l-7.107 6.889a1 1 0 0 0 1.392 1.436L19 6.362V9h2V4a1 1 0 0 0-1-1"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgOpenInNew;
